//GeocodeTool.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as GeocodeTool from "../Search/GeocodeTool";
import * as MainMap from "../MainMap";
import * as Settings from "../Settings";

import { Accordion, AccordionDetails, AccordionSummary, Icon } from "@mui/material";

import React from "react";

import PictureMarkerSymbol from "@arcgis/core/symbols/PictureMarkerSymbol";

const toolDiv: string = "geocoder_div";
export let searchWidget: __esri.widgetsSearch;
export let searchText: string = "";

//Setters.
export function setSearchText(text: string) {
   searchText = text;
}

let expanded: boolean = false;

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of GeocodeTool Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      import("@arcgis/core/widgets/Search/LocatorSearchSource").then(({ default: LocatorSearchSource }) => {
         import("@arcgis/core/widgets/Search").then(({ default: SearchWidget }) => {

            if (Settings.geocode.enabled) {
               const geocodeSources: __esri.LocatorSearchSource[] = [];

               if (Settings.geocode.address.url) {
                  const pictureMarkerSymbol = new PictureMarkerSymbol({
                     url: "Images/Flag_1.png", width: 18, height: 18, xoffset: 9, yoffset: 9,
                  });

                  const geocodeSource1 = new LocatorSearchSource({
                     url: Settings.geocode.address.url,
                     name: Settings.geocode.address.title,
                     placeholder: Settings.geocode.address.placeholder,
                     singleLineFieldName: Settings.geocode.address.singleLineFieldName,
                     resultSymbol: pictureMarkerSymbol,
                  });
                  geocodeSources.Add(geocodeSource1);
               }

               if (Settings.geocode.street.url) {
                  const pictureMarkerSymbol = new PictureMarkerSymbol({
                     url: "Images/Flag_1.png", width: 18, height: 18, xoffset: 9, yoffset: 9,
                  });

                  const geocodeSource2 = new LocatorSearchSource({
                     url: Settings.geocode.street.url,
                     name: Settings.geocode.street.title,
                     placeholder: Settings.geocode.street.placeholder,
                     singleLineFieldName: Settings.geocode.street.singleLineFieldName,
                     resultSymbol: pictureMarkerSymbol,
                  });
                  geocodeSources.Add(geocodeSource2);
               }

               let useWorldGeocoder: boolean = false;
               if (geocodeSources.length === 0) {
                  useWorldGeocoder = true;
               }

               searchWidget = new SearchWidget({
                  allPlaceholder: "",
                  container: toolDiv,
                  includeDefaultSources: useWorldGeocoder,
                  locationEnabled: false,
                  maxResults: 6,
                  maxSuggestions: 6,
                  popupEnabled: false,
                  searchTerm: GeocodeTool.searchText,
                  sources: geocodeSources,
                  view: MainMap.activeView,
               });

            } //end enable geocoder.
         });
      });
   }, []);

   //Expansion panel click event.
   function expandClicked() {
      expanded = !expanded; //Toggle it.
      refresh();
   }

   //Beige
   const styles: Default.iStyles = {
      expansionPanelMain: { marginTop: 25, backgroundColor: "Beige" },
      expansionPanelSummary: { minHeight: 35, height: 35, paddingLeft: 15, paddingRight: 15 },
      expansionPanelDetails: { padding: '1px 0px 9px 0px', backgroundColor: Settings.paperColor },
      geocoder: { backgroundColor: Settings.paperColor, marginTop: 4, marginLeft: 5 },
   };

   if (Settings.geocode.enabled) {
      return (
         <Accordion style={styles.expansionPanelMain} expanded={expanded}>
            <AccordionSummary onClick={expandClicked} expandIcon={<Icon>arrow_drop_down</Icon>} style={styles.expansionPanelSummary}>
               {Settings.geocode.overallPlaceholder}
            </AccordionSummary>

            <AccordionDetails style={styles.expansionPanelDetails}>
               <div id={toolDiv} style={styles.geocoder}></div>
            </AccordionDetails>
         </Accordion>
      ); //end return.

   } else {
      return (<div />);
   }

} //end function.
